import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { useMemo } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { B as Box } from '../Box/Box.js';

var _excluded = ["sx", "minColumnWidth", "gap", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Grid(_ref) {
  var _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    _ref$minColumnWidth = _ref.minColumnWidth,
    minColumnWidth = _ref$minColumnWidth === void 0 ? "180px" : _ref$minColumnWidth,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? "base.spacing.x4" : _ref$gap,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var mergedSx = useMemo(function () {
    return merge({
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(".concat(minColumnWidth, ", 1fr))"),
      gap: gap,
      alignItems: "stretch",
      width: "100%"
    }, sx);
  }, [sx, gap, minColumnWidth]);
  return jsx(Box, _objectSpread(_objectSpread({}, props), {}, {
    sx: mergedSx,
    className: "".concat(className !== null && className !== void 0 ? className : "", " Grid")
  }));
}
Grid.displayName = "Grid";

export { Grid as G };
//# sourceMappingURL=Grid.js.map
